import React from 'react';
import { Link } from 'react-router-dom';
import useDarkMode from '../../hooks/useDarkMode';

const RowList = ({
  rows=[],
  helpSections = [],
  toggleHelpSection = () => {},
}) => {
  const dark = useDarkMode();
  return (
    <div className="row-list">
      {rows.map((row, index) => {
        const {
          rowStyle = {},
          labelStyle = {},
          labelTitle = "",
          labelSpanStyle = {},
          valueStyle = {},
          disabled = false,
          link,
          unit = "",
          valueComponent
        } = row;
        const isSectionHeader =
          !Object.prototype.hasOwnProperty.call(row, "value") &&
          valueComponent === undefined &&
          !link &&
          !row.onEdit;

        if (disabled)
          return null;

        const ConditionalElement = link ? Link : "div";
        const value = typeof row.value === "number" ? (
          row.value % 1 === 0 ? (
            row.value
          ) : (
            row.value.toFixed(2)
          )
        ) : (
          row.value
        );

        const helpSectionItem = helpSections.find(h => h.title === row.label);
        return (
          <div
            key={row.label + index}
            style={{
              display: "flex",
              flex: 1,
              ...rowStyle
            }}
            // title={row.labelTitle}
            className={`row-list-parent${isSectionHeader ? " row-list-parent--section" : ""}`}
          >
            <div
              style={{
                flex: "1",
                fontWeight: isSectionHeader ? '600' : '500',
                margin: "0px",
                borderRadius: "0",
                // border: 'solid rgba(0,0,0,0.2) 1px',
                display: 'flex',
                alignItems: 'center',
                color: dark ? "#f8fafc" : "var(--text-color)",
                ...labelStyle
              }}
              className="app-item"
            >
              <span
                style={labelSpanStyle || {}}
                title={labelTitle}
              >
                {row.label}
              </span>
                {helpSectionItem &&
                  <span
                    className="dark-grey"
                  onClick={() => toggleHelpSection()}
                  style={{
                    cursor: 'pointer'
                  }}
                >
                  <i className="material-icons">help</i>
                </span>
              }
            </div>
            {!isSectionHeader &&
              <ConditionalElement
                style={{
                  flex: "1",
                  margin: "0px",
                  borderRadius: "0",
                  // border: 'solid rgba(0,0,0,0.2) 1px',
                  display: 'flex',
                  alignItems: 'center',
                  color: dark ? '#f8fafc' : 'var(--text-color)',
                  textDecoration: link ? "underline" : "",
                  whiteSpace: "pre-line",
                  ...valueStyle
                }}
                className="app-item"
                to={link}
              >
                {valueComponent ? (valueComponent) :
                row.onEdit ? (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      cursor: 'pointer'
                    }}
                    className="hover-show"
                    onClick={row.onEdit}
                  >
                    <span>{value} {unit}</span>
                    <span className="hover-item">
                      <i className="material-icons" style={{ color: "var(--text-soft-color)", marginLeft: "5px" }}>edit</i>
                    </span>
                  </div>
                ) : (
                  <React.Fragment>{value} {unit}</React.Fragment>
                )
                }
              </ConditionalElement>
            }

          </div>
        )
      })}
    </div>
  )
};

export default RowList;
